const selectors = {
  toggle: 'data-toggle-grid',
  large: 'data-grid-large',
  small: 'data-grid-small',
};

const classes = {
  active: 'is-active',
};

const options = {
  breakpoint: window.theme.sizes.small,
};

var sections = {};

class Toggle {
  constructor(toggle, container) {
    this.container = container || document;
    this.toggle = toggle;
    this.value = this.toggle.getAttribute(selectors.toggle);
    this.toggleFunction = (evt) => this.toggleEvent(evt);

    this.init();
  }

  init() {
    this.toggle.addEventListener('click', this.toggleFunction);
    document.addEventListener('theme:resize:width', this.toggleFunction);
    this.toggleEvent(false);
  }

  unload() {
    this.toggle.removeEventListener('click', this.toggleFunction);
    document.removeEventListener('theme:resize:width', this.toggleFunction);
  }

  toggleEvent(evt = true) {
    const clickEvent = evt && evt.type === 'click';
    const isLarge = window.innerWidth >= options.breakpoint;
    const selector = isLarge ? selectors.large : selectors.small;
    const grid = this.container.querySelector(`[${selector}]`);
    const gridNumber = grid.getAttribute(selector);
    const activeToggle = this.toggle.parentElement.querySelector(`[${selectors.toggle}].${classes.active}`);
    let currentToggle = this.toggle.parentElement.querySelector(`[${selectors.toggle}="${gridNumber}"]`);

    if (clickEvent) {
      currentToggle = this.toggle;

      grid.setAttribute(selector, this.value);
    }

    if (activeToggle) {
      activeToggle.classList.remove(classes.active);
    }

    if (currentToggle) {
      currentToggle.classList.add(classes.active);
    }
  }
}

const toggleSection = {
  onLoad() {
    sections[this.id] = [];
    const buttons = this.container.querySelectorAll(`[${selectors.toggle}]`);
    buttons.forEach((button) => {
      sections[this.id].push(new Toggle(button, this.container));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((toggle) => {
      if (typeof toggle.unload === 'function') {
        toggle.unload();
      }
    });
  },
};

export default toggleSection;
